/* eslint-disable no-unused-vars */
import React from "react";
import { useTranslation } from "react-i18next";
import Utilities from "../../lib/Utilities";

const util = new Utilities();

export default function StoreList(props) {
  const { loading, storeList, isStoreListView, showSelectedStoreDetail } =
    props;
  const { t } = useTranslation();

  return (
    <div className="flex-fill overflow_scroll px-2">
      {loading && (
        <div className="w-100 h-100 d-flex flex-row justify-content-center align-items-center">
          <i className="icon-spin5 animate-spin h4 text-secondary" />
        </div>
      )}

      {storeList.length > 0 &&
        !loading &&
        isStoreListView &&
        storeList.map((store, index) => {
          let storeImages = store.sdPhoto;
          let storeImageLink = null;
          if (storeImages) {
            let splitData = storeImages.split("|")[0].split("?");
            storeImageLink = splitData[0];
          }
          let rating = Math.round(store.srRating * 10) / 10;

          return (
            <div
              key={index}
              className="cursor-child-zoom d-flex flex-row justify-content-between align-items-center cursor_pointer transition-2 border-bottom p-2"
              onClick={() => {
                showSelectedStoreDetail(store);
              }}
            >
              {storeImageLink && (
                <div
                  className="rounded-sm overflow-hidden mr-3"
                  style={{
                    height: 90,
                    width: 90,
                    minWidth: 90,
                  }}
                >
                  <div
                    className="zoom-child"
                    style={{
                      height: 90,
                      width: 90,
                      minWidth: 90,
                      background: `url(${storeImageLink}) 50% 50%/cover no-repeat`,
                    }}
                  />
                </div>
              )}
              {!storeImageLink && (
                <div
                  className="bg-freiscop-05 text-secondary d-flex flex-row justify-content-center align-items-center rounded-sm mr-3"
                  style={{
                    height: 90,
                    width: 90,
                    minWidth: 90,
                  }}
                >
                  <span className="h1 mb-0 zoom-child">
                    <i className="fa-solid fa-warehouse" />
                  </span>
                </div>
              )}
              <div className="flex-fill overflow-hidden">
                <div
                  className="d-flex flex-row align-items-center"
                  style={{ marginBottom: 2, fontSize: "1.1em" }}
                >
                  {store.sdKey !== null && (
                    <span className="badge badge-info mr-1">
                      {t("storeMall.storeEntry")}
                    </span>
                  )}{" "}
                  <span className="font-weight-bold text-freiscop m-0 p-0 text-truncate">
                    {store.smName}
                  </span>
                </div>
                <p className="p-0 m-0 text-truncate font-size-09">
                  {store.smFormattedAddr}
                </p>
                <p className="p-0 m-0 text-truncate font-size-09">
                  {util.telFormatConvert(store.smTel)}
                </p>
                <p className="font-weight-normal font-size-09">
                  {store.smCustoms}
                </p>
                {rating > 0 && (
                  <div className="font-size-08 text-secondary mt-2">
                    {t("storeMall.review")} {rating}
                    <i className="icon-star text-warning" />({store.srCount}
                    {t("storeMall.count")})
                  </div>
                )}
              </div>
            </div>
          );
        })}
      {storeList.length === 0 && !loading && isStoreListView && (
        <div className="w-100 h-100 d-flex flex-row justify-content-center align-items-center py-3">
          <p className="h6 mb-0 font-weight-bold text-secondary">
            {t("storeMall.storeList.msg.noStore")}
          </p>
        </div>
      )}
    </div>
  );
}
